import React from "react";

import { useHasPermission } from "@/permissions";
import { AssessmentsMenu } from "../AssessmentsMenu/AssessmentsMenu";
import { AssessmentsReviewMenu } from "../AssessmentsMenu/AssessmentsReviewMenu";
import { AssignReviewersMenu } from "../AssignReviewersMenu/AssignReviewersMenu";
import TasksComparisonMenu from "../TasksComparisonMenu/TasksComparisonMenu";
import { useSelectedMenu } from "./hooks";

export const Menu = () => {
  const [selectedMenu, _] = useSelectedMenu();
  const isVerifier = useHasPermission("verifier", true);

  let menu: React.ReactElement | null = null;
  if (selectedMenu === "assessments") {
    menu = <AssessmentsMenu mode={isVerifier ? "verifier" : "data_provider"} />;
  }

  if (selectedMenu === "review") {
    menu = <AssessmentsReviewMenu />;
  }

  if (selectedMenu === "assign_reviewers") {
    menu = <AssignReviewersMenu />;
  }

  if (selectedMenu === "tasks_comparison") {
    menu = <TasksComparisonMenu />;
  }

  return menu;
};
